import { Component, ViewChild } from '@angular/core';
import { NavController, Content, ToastController, Events, ModalController, ActionSheetController } from 'ionic-angular';
import { Socket } from 'ng-socket-io';
import { Observable } from 'rxjs/Observable';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

// import { ProfilecheckPage } from '../profilecheck/profilecheck';

/* Api */
import{ ApiProvider } from '../../providers/api/api';

/* Cripto */
import{ ChatProvider } from '../../providers/chat/chat';

/* Storage */
import { Storage } from '@ionic/storage';

import { AuthProvider } from '../../providers/auth/auth';

@Component({
    selector: 'page-mensagens',
    templateUrl: 'mensagens.html',
})

export class MensagensPage {

    @ViewChild(Content) content: Content
    conversa = [];
    btnmais = false;
    loading;
    mensagem: string;
    paginaCarregada = 'transparent';

    usuario = {id: 0, nome:''};

    empresa = {id:0, nome: '', imagem:''};

    pag = 1;

    constructor(public navCtrl: NavController, private toastCtrl: ToastController, private socket: Socket, public storage: Storage, public _apiService: ApiProvider, public events: Events, public modalCtrl: ModalController, private _chat: ChatProvider, public actionSheetCtrl: ActionSheetController, private _msg: TranslateMsgProvider, private _auth: AuthProvider)
    {
    }

    ionViewDidEnter() {
        this.conversa = [];
        this._auth.checkempresa();
        this.initPage();

        this.storage.set('viewMsg', 1);
    }

    ionViewDidLeave()
    {
        this.storage.set('viewMsg', 0);
        this.socket.disconnect();
    }

    initPage()
    {
        if(this.usuario.id == 0)
        {
            this.storage.get('id_cliente').then((val) => {
                this.usuario.id = val;
                this.getEmpresa();
            });
            this.storage.get('nome').then((val) => {
                this.usuario.nome = val;
            });
        }
        else
        {
            this.getEmpresa();
        }
    }

    getEmpresa()
    {
        if(this.empresa.id == 0)
        {
            this.storage.get('id_empresa_escolhida').then((val) => {
                this.empresa.id = val;
                this._apiService.getConfig({id_empresa_escolhida:this.empresa.id, id_cliente:this.usuario.id}).subscribe(arg =>
                {
                    // console.log(arg);
                    this.empresa.nome = arg['nomeEmpresa'];
                    this.empresa.imagem = arg['logo'];
                });
                this.getDados();
            });
        }
        else
        {
            this.getDados();
        }
    }


    getDados()
    {
        this.socket.connect();

        this.socket.emit('set-empresa', this.empresa.id);
        this.socket.emit('set-cliente', this.usuario.id);

        this.loading = this.toastCtrl.create({message: this._msg.getMsg('CARREGANDO')+'...', position: 'top'});

        this.getMessages().subscribe(message => {
            this.adicionaMensagensConversa(message, true);
        });

        this.loading.present();

        this.getConversa();
    }

    /* Pega os detalhes do match */
    getConversa()
    {
        // console.log(this.version);
        this._apiService.returnMensages({id_cliente: this.usuario.id, id_empresa_escolhida: this.empresa.id}).subscribe(
        arg=>{
            this.btnmais = arg.maismsg;

            for (var i = 0; i < arg.mensagens.length; ++i)
            {
                this.adicionaMensagensConversa(arg.mensagens[i], false);
            }

            this.paginaCarregada = '';
            this.loading.dismiss();

            setTimeout( () => {
                this.scroll();
            }, 50);
        },
        error=>{
            this.loading.dismiss();
        });
    }

    /* Pega as mensagens */
    getMessages()
    {
        let observable = new Observable(observer => {
            this.socket.on('message', 
            (data) => {
                // console.log('teste -> ', data);
                if((data.empresa == this.empresa.id) && (data.cliente == this.usuario.id))
                {
                    observer.next(data);
                }
            });
        })
        return observable;
    }

    /* Adiciona as mensagens na variavel */
    adicionaMensagensConversa(mensagem, novo)
    {
        // console.log(mensagem);
        let nova = {data:'', hora:'', dia: '', mensagem:'', classe:'outro', attr1: true, attr2: false, imagem: '', id: mensagem.id_m, icon: 'checkmark', temp: false};

        if(mensagem.cript == 0)
        {
            nova.mensagem = mensagem.msg;
        }
        else
        {
            nova.mensagem = this._chat.decrypt(mensagem.msg);
        }

        nova.hora = mensagem.hora;
        nova.dia = mensagem.dia;

        nova.data = mensagem.dia;

        if(this.conversa.length > 0)
        {
            if(this.conversa[this.conversa.length - 1]['dia'] == mensagem.dia)
            {
                nova.data = '';
            }
        }

        if(mensagem.remetente == 'cliente')
        {
            if((typeof mensagem.temporaria !== 'undefined')||(mensagem.temporaria))
            {
                // console.log('if1');
                nova.icon = 'time';
                nova.temp = true;

                // Adiciona no array de mensagens temporarias
                let temporaria = {'data': mensagem.data, 'id_user':this.usuario.id, 'id_emp':this.empresa.id, 'msg': mensagem.msg, 'time': mensagem.time};

                // Verifica se tem alguma no storage
                this.storage.get('mensagensTemporarias').then((mensagensT) => {
                    if(mensagensT == null)
                    {
                        mensagensT = [];
                    }

                    mensagensT.push(temporaria);
                    this.storage.set('mensagensTemporarias', mensagensT);
                });
            }
            // Verifica mensagens temporarios
            else if(this.checkTemporarias(nova))
            {
                return '';
            }
            nova.classe = "eu";
            nova.attr1 = false;
            nova.attr2 = true;
        }
        else
        {
            // Se a mensagem não está marcada como visualizada
            if(typeof mensagem.visualizado === 'undefined')
            {
                this._apiService.visualizaMsg({id:mensagem.id_m}).subscribe(arg=>{
                    console.log('Mensagem lida', arg);
                    // this.checkMsgApi();
                });
            }
        }
        // console.log(nova);
        
        this.conversa.push(nova);

        if(novo)
        {
            setTimeout( () => {
                this.scroll();
            }, 200);
        }
    }

    scroll()
    {
        if(this.content._scroll)
        {
            this.content.scrollToBottom();
        }
    }

    // Verifica mensagens temporárias 
    checkTemporarias(nova)
    {
        let auxm;
        // Verifica se tem alguma mensagem temporaria para mudar
        for (var i = 0; i < this.conversa.length; ++i)
        {
            if((this.conversa[i].mensagem == nova.mensagem) && (this.conversa[i].dia == nova.dia) && (this.conversa[i].hora == nova.hora))
            {
                if(this.conversa[i].temp)
                {
                    this.conversa[i].temp = false;
                    this.conversa[i].icon = 'checkmark';

                    // Tira tambem do storage
                    this.storage.get('mensagensTemporarias').then((mensagensT) => {
                        if(mensagensT != null)
                        {
                            for (var j = 0; j < mensagensT.length; ++j)
                            {
                                auxm = this._chat.decrypt(mensagensT[j].msg);
                                if(this.conversa[i].mensagem == auxm)
                                {
                                    this.conversa[i].id = nova.id;
                                    mensagensT.splice(j, 1);
                                    this.storage.set('mensagensTemporarias', mensagensT);
                                    return true;
                                }
                            }
                        }
                    });
                    return true;
                }
                else if(this.conversa[i].id == nova.id)
                {
                    return true;
                }
            }
        }

        return false;
    }

    /* Envia as mensagens */
    sendMessage()
    {
        console.log('sendMessage');
        // let txt = this.mensagem;
        // Verifica se a mensagem não é um espaço
        if(this.mensagem.trim() != "")
        {
            let txt = this._chat.encrypt(this.mensagem);

            // Mensagem temporaria
            let agora = new Date();
            
            let res = this.socket.emit('add-message', { text: txt, remetente:'cliente' });

            txt = '';
            this.mensagem = '';
        }
    }

    doRefresh(refresher)
    {
        this._apiService.getMaisMensagens({pag: this.pag, id_empresa_escolhida: this.empresa.id, id_cliente: this.usuario.id}).subscribe(
        arg=>{
            console.log(arg);
            this.pag += 1;

            this.btnmais = arg.maismsg;

            let conversaAtual = this.conversa;
            let idmensagem = this.conversa[0].id;
            this.conversa = [];

            for (var i = 0; i < arg.mensagens.length; ++i)
            {
                this.adicionaMensagensConversa(arg.mensagens[i], false);
            }

            for (var j = 0; j < conversaAtual.length; ++j)
            {
                this.conversa.push(conversaAtual[j]);
            }

            refresher.complete();
            // // console.log(idmensagem);

            setTimeout(() => {
                let yOffset = document.getElementById("mensagem"+idmensagem).offsetTop;
                this.content.scrollTo(0, yOffset-60, 0);
                // console.log(yOffset);
            }, 100);
            
        },
        error=>{
            refresher.complete();
            this.loading.dismiss();
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/mensagens/mensagens.ts